<script>
import LogSavedSearchForm from '@/components/Log/LogSavedSearchForm.vue';
import LogSavedSearchDeleteForm from '@/components/Log/LogSavedSearchDeleteForm.vue';
import RexDropDownV3 from '@/rex-components/RexDropDownV3.vue';
import { LOGService } from '@/services/api/log.service';
import { notificationError, notificationSucess } from '@/utils/notification';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { CAPABILITY_LOG, CAPABILITY_ANALYTICS } from '@/utils/constants';
import log from '@/utils/templates/log.template';
import {
  ADD_WIDGET_MENU_KEY,
  ALERT_MENU_KEY,
  DELETE_MENU_KEY,
  EDIT_MENU_KEY,
  METRIC_QUERY_TYPE,
  RUN_MENU_KEY,
} from '@/components/Log/log.constants';
import { savedSearchTableMenuItems } from '@/components/Log/log.types';
import analytics from '@/utils/templates/analytics.template';
import { getRouteName } from '@/components/Log/log.types';
import { CustomService } from '@/services/api/custom.service';
import {
  LOG_RESOURCE_GROUP,
  ANALYTICS_RESOURCE_GROUP,
  HOME_RESOURCE_GROUP,
} from '@/router/constant';
import { usePermissions } from '@/hooks/usePermissions';
import { permissionTypes } from '@/router/constant';
const { hasCapabilityWritePermission, hasCapabilityAlertWritePermission } =
  usePermissions();

export default {
  components: { LogSavedSearchForm, LogSavedSearchDeleteForm, RexDropDownV3 },
  props: {
    rowDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('globalState/user', ['teamID']),
    ...mapState('logState/logCommonState', [
      'isAddWidgetWithoutSavedSearch',
      'isADType',
    ]),
    ...mapGetters('logState/logCommonState', ['getCapabilityType']),
    initSavedSearchValues() {
      return {
        searchName: this.rowDetails.savedQueryName,
        queryStr: this.rowDetails.query,
        savedQueryType: this.rowDetails.savedQueryType,
      };
    },
    dispAlertIcon() {
      return (
        this.rowDetails?.savedQueryType === METRIC_QUERY_TYPE &&
        this.hasAlertWritePermission
      );
    },
    getMenuItems() {
      return savedSearchTableMenuItems().filter((obj) => {
        if (obj.isLMANLRole) return this.hasLMORANLWritePermission;
        if (obj.isAlertView) return this.dispAlertIcon;
        if (obj.isHomeRole)
          return this.hasHomeWritePermission && this.hasLMORANLWritePermission;
        return true;
      });
    },
    hasLMORANLWritePermission() {
      return hasCapabilityWritePermission(
        this.isADType ? ANALYTICS_RESOURCE_GROUP : LOG_RESOURCE_GROUP,
      );
    },
    hasHomeWritePermission() {
      return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
    },
    hasAlertWritePermission() {
      return hasCapabilityAlertWritePermission(
        this.isADType ? ANALYTICS_RESOURCE_GROUP : LOG_RESOURCE_GROUP,
      );
    },
  },
  data() {
    return {
      openEditForm: false,
      openDeleteForm: false,
      isLoading: false,
    };
  },
  methods: {
    ...mapMutations('logState/logCommonState', [
      'setReloadSavedSearchTable',
      'setWidgetFormData',
      'setExecuteSavedSearch',
      'resetExecuteSavedSearch',
    ]),
    ...mapMutations('alertV2State/configure', [
      'setCurrentAlertApplication',
      'setCurrentAlertCapability',
      'setShowAddConfigureAlert',
    ]),
    async editSavedSearch(searchDetails) {
      try {
        this.isLoading = true;
        const searchData = {
          savedQueryName: searchDetails.searchName,
          query: searchDetails.query,
          team_id: this.teamID,
          capability: this.getCapabilityType,
        };
        const { data } = await LOGService.addSavedSearchData(searchData);

        if (data.success) {
          const metricData = {
            metric_name: data?.data?.queryMetric,
            service_id: this.rowDetails?.service_id,
            update: true,
          };
          await CustomService.reMapIndex(metricData);
          notificationSucess(this.$t('log.updateSavedSearchSuccMsg'));
          this.setReloadSavedSearchTable(true);
          this.openEditForm = false;
        } else {
          notificationError(this.$t('log.updateSavedSearchErrMsg'));
        }
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isLoading = false;
        const formErrMsg =
          (error.status === 400 && error?.data?.errors?.message) ||
          this.$t('log.updateSavedSearchErrMsg');
        notificationError(formErrMsg);
      }
    },
    async deleteSavedSearch() {
      try {
        this.isLoading = true;
        await LOGService.deleteSavedSearch(this.rowDetails?.id);
        notificationSucess(this.$t('log.deleteSavedSearchSuccMsg'));
        this.setReloadSavedSearchTable(true);
        this.openDeleteForm = false;
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        notificationError(this.$t('log.deleteSavedSearchErrMsg'));
        this.openDeleteForm = false;
        this.isLoading = false;
      }
    },
    executeSavedSearch() {
      this.resetExecuteSavedSearch();
      this.setExecuteSavedSearch({
        field: 'isTextSearchTypeSelected',
        value: this.$route.query.isSqlQuery == 'false',
      });
      this.setWidgetFormData({
        field: 'isCreateOrUpdateSavedSearch',
        value: true,
      });
      this.setWidgetFormData({
        field: 'isQueryExecuted',
        value: true,
      });
      this.$router.push({
        name: getRouteName(this.isADType),
        query: {
          ...this.$route.query,
          queryExec: this.rowDetails?.query,
          isSqlQuery: true,
        },
      });
    },
    executeAddWidget() {
      this.setExecuteSavedSearch({
        field: 'isTextSearchTypeSelected',
        value: this.$route.query.isSqlQuery == 'false',
      });
      this.setExecuteSavedSearch({
        field: 'savedSearchName',
        value: this.rowDetails.savedQueryName,
      });
      this.setExecuteSavedSearch({
        field: 'service_id',
        value: this.rowDetails.service_id,
      });
      this.setExecuteSavedSearch({
        field: 'isAddWidgetWithoutSavedSearch',
        value: true,
      });
      this.setExecuteSavedSearch({
        field: 'queryMetric',
        value: this.rowDetails.queryMetric,
      });
      this.setWidgetFormData({
        field: 'isCreateOrUpdateSavedSearch',
        value: false,
      });
      this.$router.push({
        name: getRouteName(this.isADType),
        query: {
          ...this.$route.query,
          queryExec: this.rowDetails?.query,
          isSqlQuery: true,
        },
      });
    },
    redirectToAlerts() {
      const currentAlertCap = this.isADType
        ? {
            key: CAPABILITY_ANALYTICS,
            label: analytics.name,
          }
        : {
            key: CAPABILITY_LOG,
            label: log.name,
          };
      this.setCurrentAlertCapability(currentAlertCap);
      this.setCurrentAlertApplication({
        key: this.rowDetails.service_id,
        label: this.rowDetails.savedQueryName,
        permissions: permissionTypes.ALERT_WRITE,
      });
      this.setShowAddConfigureAlert(true);
      this.$router.push({ name: 'configuredV2' });
    },
    onItemClick(item) {
      switch (item.key) {
        case EDIT_MENU_KEY:
          this.openEditForm = true;
          break;
        case DELETE_MENU_KEY:
          this.openDeleteForm = true;
          break;
        case RUN_MENU_KEY:
          this.executeSavedSearch();
          break;
        case ADD_WIDGET_MENU_KEY:
          this.executeAddWidget();
          break;
        case ALERT_MENU_KEY:
          this.redirectToAlerts();
          break;
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="saved-search-actions-box">
      <RexDropDownV3
        :items="getMenuItems"
        @itemClick="onItemClick"
        :overlayStyle="{ width: '12rem' }"
      >
        <BaseIcon
          name="menu-icon"
          iconColor="rgb(180, 180, 180)"
          class="saved-search-actions-icon"
        />
      </RexDropDownV3>
    </div>

    <LogSavedSearchForm
      v-if="openEditForm"
      @onSubmit="editSavedSearch"
      @onClose="openEditForm = false"
      :isLoading="isLoading"
      :isEdit="true"
      :initValues="initSavedSearchValues"
    />

    <LogSavedSearchDeleteForm
      v-if="openDeleteForm"
      @onSubmit="deleteSavedSearch"
      @onClose="openDeleteForm = false"
      :isLoading="isLoading"
      :saveSearchName="rowDetails.savedQueryName"
      :serviceId="rowDetails.service_id"
    />
  </div>
</template>

<style lang="scss" scoped>
.saved-search-actions-box {
  display: flex;
  justify-content: flex-end;
}
.saved-search-delete-icon {
  @include svg-fill-pointer($color-brand-accent);
  margin-left: 1.188rem;
}
.saved-search-edit-icon {
  @include svg-fill-pointer($color-brand-accent);
}
.saved-search-run-icon {
  @include svg-fill-pointer($color-brand-accent);
  margin-left: 1.188rem;
  stroke: $color-brand-accent;
}
.saved-search-actions-icon {
  padding: 0rem 0.5rem;
  cursor: pointer;
}
</style>
